import { z } from "zod/v4";
import { createEndpointBase } from "./core";
import {
  AuditTrailFilterSchema,
  AuditTrailScriptViewFilterSchema,
  AuditTrailProjectViewFilterSchema,
  GetRequestBaseResponseSchema,
} from "../ea.schema.query";
import {
  AuditTrailProjectViewSchema,
  AuditTrailSchema,
  AuditTrailScriptViewSchema,
} from "../ea.schema";
import { AuditTrailSettingsViewSchema } from "../ea.schema";

const base = "auditTrail";
const audit = createEndpointBase(base);
const viewScript = createEndpointBase(base, "script");
const viewProject = createEndpointBase(base, "project");
const viewSettings = createEndpointBase(base, "settings");

export const auditTrailEndpoints = {
  auditTrailGet: audit({
    method: "GET",
    path: "",
    request: z.object({ filter: AuditTrailFilterSchema.optional() }).optional(),
    response: GetRequestBaseResponseSchema(AuditTrailSchema),
    description: "Retrieves a list of general audit logs with filtering support.",
  }),

  auditTrailViewScriptGet: viewScript({
    method: "GET",
    path: "",
    request: z.object({ filter: AuditTrailScriptViewFilterSchema.optional() }).optional(),
    response: GetRequestBaseResponseSchema(AuditTrailScriptViewSchema),
    description: "Retrieves script-specific audit logs with filtering support.",
  }),

  auditTrailViewProjectGet: viewProject({
    method: "GET",
    path: "",
    request: z.object({ filter: AuditTrailProjectViewFilterSchema.optional() }).optional(),
    response: GetRequestBaseResponseSchema(AuditTrailProjectViewSchema),
    description: "Retrieves project-specific audit logs with filtering support.",
  }),

  auditTrailViewSettingsGet: viewSettings({
    method: "GET",
    path: "",
    request: z.object({ filter: AuditTrailFilterSchema.optional() }).optional(),
    response: GetRequestBaseResponseSchema(AuditTrailSettingsViewSchema),
    description: "Retrieves settings-specific audit logs with filtering support.",
  }),
} as const;
